const DEFAULT_MAX_TABS = 6

export function getMaxVisibleTabCount(config: DetailViewOptions): number {
    return config.max_visible_tab_count ?? DEFAULT_MAX_TABS
}
